import Controller from '@ember/controller';
import { isPlatformDomain } from 'frontend-utils/utils/domain-checks';

export default class ApplicationLoadingController extends Controller {
  constructor() {
    super(...arguments);

    // Check if we can use the OTA logo loading animation or not.
    // In case of resellers (Tripadvisor) we use a generic Paper loading component
    this.canUseOTALoadingAnimation =
      isPlatformDomain() || window.location.href.indexOf('localhost') !== -1;
  }

  onInsertedLogo(logoElement) {
    // This code originated from the inline svg, but we moved it here for the CSP rework
    // Basically it sets the transform-box property to initial, and after the first frame to fill-box.
    // This was probably added by an auto generated export from our logo somewhere.
    const logoStyle = logoElement.querySelectorAll('style');
    const c = function (d) {
      [].forEach.call(logoStyle, (f) => {
        const g = f.textContent;
        g &&
          (f.textContent = g.replace(
            /transform-box:[^;\r\n]*/gi,
            `transform-box: ${d}`,
          ));
      });
    };
    c('initial');
    window.requestAnimationFrame(() => c('fill-box'));
  }
}
